module.exports = __webpack_public_path__ + "static/media/respond.c994e3c1.png";